import { z } from 'zod'
import {
  decimalSchema,
  moneySchema,
  positiveDecimalSchema,
  timestampSchema,
  uuidSchema,
} from './common.ts'
import { warehouseUnitCodeSchema } from './units.ts'

export const productionPlanSourceSchema = z.enum(['automatic', 'manual'])
export type ProductionPlanSource = z.infer<typeof productionPlanSourceSchema>

export const productionPlanMonthSchema = z
  .string()
  .regex(/^\d{4}-(0[1-9]|1[0-2])$/, 'Вкажіть місяць у форматі РРРР-ММ')

const nonNegativeMoneySchema = moneySchema.refine(
  (value) => !value.startsWith('-'),
  'Сума не може бути від’ємною',
)

export const createManualProductionPlanInputSchema = z.strictObject({
  productName: z.string().trim().min(1).max(500),
  quantity: positiveDecimalSchema,
  unitCode: warehouseUnitCodeSchema,
  amountUah: nonNegativeMoneySchema,
  plannedMonth: productionPlanMonthSchema,
  legalEntityId: uuidSchema,
  clientName: z.string().trim().min(1).max(300).nullable().default(null),
  deadline: z.iso.date().nullable().default(null),
  note: z.string().trim().min(1).max(2000).nullable().default(null),
})
export type CreateManualProductionPlanInput = z.infer<typeof createManualProductionPlanInputSchema>

export const productionPlanListQuerySchema = z.strictObject({
  month: productionPlanMonthSchema,
})
export type ProductionPlanListQuery = z.infer<typeof productionPlanListQuerySchema>

export const productionPlanRowSchema = z.object({
  id: uuidSchema,
  source: productionPlanSourceSchema,
  productName: z.string(),
  quantity: decimalSchema,
  unit: z.string(),
  amountUah: decimalSchema,
  plannedMonth: z.iso.date(),
  legalEntityId: uuidSchema,
  legalEntityName: z.string(),
  clientName: z.string().nullable(),
  deadline: timestampSchema.nullable(),
  orderId: uuidSchema.nullable(),
  orderNumber: z.string().nullable(),
  currencyCode: z.string().nullable(),
  exchangeRate: decimalSchema.nullable(),
  exchangeRateUnits: decimalSchema.nullable(),
  note: z.string().nullable(),
  archivedAt: timestampSchema.nullable(),
  createdAt: timestampSchema,
})
export type ProductionPlanRow = z.infer<typeof productionPlanRowSchema>

export const productionPlanLegalEntityTotalSchema = z.object({
  legalEntityId: uuidSchema,
  legalEntityName: z.string(),
  totalUah: decimalSchema,
})

export const productionPlanSchema = z.object({
  rows: z.array(productionPlanRowSchema),
  totalUah: decimalSchema,
  totalsByLegalEntity: z.array(productionPlanLegalEntityTotalSchema),
})
export type ProductionPlan = z.infer<typeof productionPlanSchema>
